// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wBFm","type":"styles_type__1AOwh","choices":"styles_choices__3IS10"};